import React from 'react';
import Layout from '../../src/components/Layout/Layout';
import TermsComponent from '../../src/components/Terms/Terms';

const Terms = () => (
  <Layout>
    <TermsComponent />
  </Layout>
);

export default Terms;
